export default __webpack_public_path__ + "static/media/send.1a9a18a0.webp";